'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.scrollTriggerEnabled = undefined;

var _getMessage = require('conversations-schema/operators/widget-data/getMessage');

var _getClientTriggers = require('conversations-schema/operators/message/getClientTriggers');

var _clientTriggersGetters = require('conversations-schema/client-triggers/operators/clientTriggersGetters');

var _scrollPercentageTriggerGetters = require('conversations-schema/client-triggers/operators/scrollPercentageTriggerGetters');

var scrollTriggerEnabled = exports.scrollTriggerEnabled = function scrollTriggerEnabled(widgetData) {
  var message = (0, _getMessage.getMessage)(widgetData);
  var clientTriggers = (0, _getClientTriggers.getClientTriggers)(message);
  var displayOnScrollPercentage = (0, _clientTriggersGetters.getDisplayOnScrollPercentage)(clientTriggers);
  var enabled = (0, _scrollPercentageTriggerGetters.getEnabled)(displayOnScrollPercentage);

  return enabled;
};